import state from "@/store/modules/scheduled-note/state";
import actions from "@/store/modules/scheduled-note/actions";
import mutations from "@/store/modules/scheduled-note/mutations";
import getters from "@/store/modules/scheduled-note/getters";

export default {
  state,
  actions,
  mutations,
  getters
}